<template>
  <div class="groupDetail">
    <topBanner v-if="!$store.state.isMobile"></topBanner>
    <div class="shareIcon" v-if="shareToOthersModel && showShareModel">
      点击右上角，选择分享给好友
      <img src="../../assets/ticket/share.png">
    </div>
    <div v-if="!$store.state.isMobile" class="pcContent handelBlock">
      <!-- <div class="buttonLine">
        <div class="buttonWhite">我的订单</div>
        <div class="toIndex">返回首页</div>
      </div> -->
      <pcTabs :reservationType="2"></pcTabs>
      <div class="line">开馆时间 <span>{{detail.time}}</span></div>
    </div>
    <div :class="$store.state.isMobile ? '' : 'pcItemCard'" :style="$store.state.ticketDetail.explainOn && !isFid ? 'margin-bottom: 150px;' : 'margin-bottom: 0'">
      <groupMessage :group="group" :detail="detail"></groupMessage>
      <div :class="`buttonText ${$store.state.isMobile ? '' : 'dissolutionGroup'}`" @click="dissolutionGroup">解散团队</div>
      <div v-show="!showAddMember" :class="$store.state.isMobile ? '' : 'pcContent'">
        <div class="members">
          <div>成员信息</div>
          <div>{{members.length + 1}}人</div>
        </div>
        <div class="itemTitle">成员信息</div>
        <div class="itemCard group">
          <div class="buttons">
            <!-- h5 -->
            <div class="button" @click="addMember" v-if="$store.state.isMobile">添加成员</div>
            <div class="button" @click="shareAddMember"  v-if="$store.state.isMobile">发起分享</div>
            <!-- pc -->
            <div class="button" @click="addPcMember" v-if="!$store.state.isMobile">添加成员</div>
            <!-- pc上传模板组件 -->
            <el-upload
              v-if="!hasModel && !$store.state.isMobile"
              class="upload-demo"
              action="1111"
              ref="uploadModel"
              :http-request="actionModel"
              :limit="1"
              :show-file-list="false">
              <div class="button">批量上传成员</div>
            </el-upload>
            <div class="buttonText" @click="uploadModel" v-if="!$store.state.isMobile && !hasModel">下载成员模板</div>
          </div>
          
          <div class="nameWarp" v-if="group.id">
            <div class="nameDetail" v-for="(item, index) in [group].concat(members)" :key="index">
              <div :class="`delName ${!item.belongId ? 'noBorder' : ''}`" @click="del(item)">{{!item.belongId ? '' : '一'}}</div>
              <div>{{item.personName}}</div>
              <div>{{item.cardNum}}</div>
              <div class="buttonText" @click="edit(index)" v-if="item.belongId">编辑</div>
              <div v-if="!item.belongId" class="buttonText" style="color: #000">团长</div>
            </div>
          </div>
        </div>
        <div class="members" v-if="$store.state.ticketDetail.explainOn && !isFid && museumCode != 'ycsbwg'">
          <div>语音讲解</div>
        </div>
        <div :class="`itemCard explain`" v-if="$store.state.ticketDetail.explainOn && !isFid && museumCode != 'ycsbwg'">
          <span class="contentTitle">是否需要讲解</span>
          <el-radio-group v-model="jsonData.needExplain" :disabled="!maxExplainNum">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="2">是<span v-if="maxExplainNum != 'no'">(该时段剩余{{maxExplainNum}})</span></el-radio>
          </el-radio-group>
        </div>
        <!-- <div :class="`itemCard certificate ${$store.state.isMobile ? 'isMobile' : ''}`" v-if="$route.query.imgOrgOn">
          <span class="contentTitle">请上传团队凭证</span>
          <el-upload
            v-if="!hasUpload"
            class="upload-demo"
            :limit="1"
            action="1111"
            list-type="picture"
            :http-request="actionImg"
            :show-file-list="false">
            <div class="buttonText buttonLeft">
              请点击上传图片
            </div>
          </el-upload>
          <div v-if="hasUpload" class="buttonText hasUpload">已上传</div>
          <div v-if="hasUpload" class="buttonText cancelUpload" @click="hasUpload = false">取消</div>
        </div>
        <div class="itemWarpLine" v-if="$store.state.isMobile">
          <el-checkbox v-model="hasReadNotice"></el-checkbox>
          <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">团队预约须知</span>
          <div class="noticeText">请仔细阅读后并勾选</div>
        </div> -->
        
        <div class="buttonNormal" v-if="$store.state.isMobile" @click="submitGroupMembers">提交预约</div>
      </div>
    </div>
    <div class="pcContent" :style="$store.state.ticketDetail.explainOn ? 'margin-top: 40px;' : 'margin-top: 0'">
      <div class="itemWarpLine" v-if="!$store.state.isMobile">
        <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
        <!-- {{ museumCode }} -->
        <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">
          {{ museumCode=="hnsczsbwg"?'预约须知':"团队预约须知" }} 

          
        </span>
        <div class="noticeText">请仔细阅读后并勾选</div>
      </div>
    </div>
    <div class="button3" v-if="!$store.state.isMobile" @click="submitGroupMembers">提交预约</div>
    <addMember v-if="showAddMember" @submitAdd="submitAdd" :editData="editData" :addType="addType" title="成员信息"></addMember>
    <pop v-show="showShareModel">
      <slot>
        <div class="groupShare">
          <div class="code">团队邀请码</div>
          <div class="codeNumber">{{codeNumber}}</div>
          <p>将连接发给好友，邀请好友输入团队邀请码填写个人信息</p>
          <div class="buttonWarp">
            <div class="buttonCancel" @click="cancelShare">取消</div>
            <div class="buttonConfirm shareButton" @click="shareToOthers">分享给好友</div>
          </div>
        </div>
      </slot>
    </pop>
    <div class="pcContent">
      <pop v-if="showAddPcMember">
        <slot>
          <div class="popContent">
            <div class="title">添加成员</div>
            <div class="baseLine"></div>
            <div class="lineContent">
              <div class="name">姓名</div>
              <el-input v-model="editData.personName" placeholder="请输入姓名" :maxlength="16"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">身份证号</div>
              <el-input v-model="editData.cardNum" placeholder="请输入身份证号码"></el-input>
            </div>
            <div class="lineContent">
              <div class="name">联系电话</div>
              <el-input v-model="editData.phone" placeholder="请输入联系电话" type="number" oninput="if(value.length>11)value=value.slice(0,11)"></el-input>
            </div>
            <div class="buttonConfirm" @click="submitAdd(editData)">保存</div>
          </div>
        </slot>
      </pop>
    </div>
    <notice v-if="showNotice && $store.state.isMobile"></notice>
    <pop v-if="showNotice && !$store.state.isMobile">
      <slot>
        <div class="popContent popNoticeContent">
          <div class="popContentTitle">预约须知</div>
          <div class="popNotice" v-html="$store.state.ticketDetail.bookingNote">
          </div>
        </div>
        <div class="buttonWarp">
          <div :class="`buttonConfirm popHasRead ${readTime ? 'gayText' : ''}`" @click="hasRead">已读{{readTime ? `(${readTime}s)` : ''}}</div>
        </div>
      </slot>
    </pop>
    <pop v-if="showPop">
      <slot>
        <div class="popContent">
          <div class="popNotice">您是否确认所有团队成员已添加完成？可刷新本页更新成员信息。</div>
        </div>
        <div class="buttonWarp">
          <div class="buttonCancel" @click="closePop">取消</div>
          <div class="buttonConfirm" @click="submit">保存</div>
        </div>
      </slot>
    </pop>
    <pop v-if="showPop2">
      <slot v-if="$store.state.isMobile">
        <div :class="`popContent ${!$store.state.isMobile ? 'pcPopContent' : ''}`">
          <div class="notice">{{!$cookie.get('token') ? '您未登录，请选择' : '您登录的账号不是该团队的负责人，请选择'}}</div>
        </div>
        <div class="buttonCancel shareButton" @click="toLogin">我是团长，去登录</div>
        <div class="buttonConfirm shareButton" @click="toGroupCode">我是成员，去填写个人信息</div>
      </slot>
      <slot v-else>
        <div class="pcPopContent">
          <div class="pcNotice">请在移动端操作</div>
        </div>
      </slot>
    </pop>
  </div>
</template>

<script>
import groupMessage from '../../components/ticket/groupMessage'
import addMember from '../../components/ticket/addMember.vue'
import pop from '../../components/common/pop.vue'
import topBanner from '../../components/common/topBanner'
import notice from '../../components/common/notice.vue'
import pcTabs from '../../components//ticket/pcTabs.vue'
import Clipboard from 'clipboard'
var timeInterval
export default {
  data() {
    return {
      detail: {
        museumName: '',
        time: '19:00-21:00',
      },
      group: {},
      members: [],
      maxExplainNum: 0,
      hasReadNotice: false,
      // needExplain: 1,
      showAddMember: false,
      showShareModel: false,
      codeNumber: '324',
      addType: 'add',
      showAddPcMember: false,
      editData: {},
      noticeDetail: '',
      showNotice: false,
      belongId: '',
      museumCode: '',
      showPop: false,
      jsonData: {},
      showPop2: false,
      hasUpload: false,
      certificate: '',
      shareToOthersModel: false,
      uploadTime: 0,
      hasOpenNotice: false,
      hasModel: false,
      formData: {},
      isFid: false,
      orderDetail: {},
      readTime: 3
    };
  },

  components: {groupMessage, addMember, pop, topBanner, notice, pcTabs},

  methods: {
    // 下载成员模板
    uploadModel() {
      let text = '团队成员模板.xlsx'
      location.href = encodeURI(location.origin + location.pathname + text)
    },
    // 批量上传
    actionModel(params) {
      this.formData = new FormData();
      // let formData = new FormData();
      this.formData.append("file", params.file);
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post(`/api/ticket/front/people/import-excel?museumCode=${this.museumCode}&belongId=${this.group.id}`, this.formData, config).then((res) => {
        if (res.status == 200) {
          this.hasModel = true
          this.$message.success('上传成功')
          this.getPeopleInfo()
        }else {
          this.$refs.uploadModel.clearFiles()
        }
      }).catch(() =>{
        this.$refs.uploadModel.clearFiles()
      })
    },

    changeReadNotice() {
      if (!this.hasOpenNotice) this.showNotice = true
    },

    actionImg(params) {
      let formData = new FormData();
      formData.append("file", params.file);
      formData.append('folder', `${this.museumCode}/newTicket`)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post('/api/file/upload/', formData, config).then((res) => {
        this.hasUpload = true
        this.certificate = res.data
      })
    },

    toLogin() {
      this.$router.replace('/ticket/login')
    },

    toGroupCode() {
      this.$router.replace(`/ticket/groupCode?museumCode=${this.museumCode}&belongId=${this.belongId}`)
    },

    clickNotice() {
      this.showNotice = true
    },

    edit(index) {
      this.$store.state.isMobile ? this.showAddMember = true : this.showAddPcMember = true
      this.addType = 'edit'
      this.editData = JSON.parse(JSON.stringify(this.members[index - 1]))
      this.editData.id ? this.getDetailInfo() : ''
    },

    getDetailInfo() {
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${this.editData.id}`).then((res) =>{
        res = res.data
        this.editData.cardNum = res.cardNum
        this.editData.phone = res.phone
      })
    },

    del(item) {
      if (!item.belongId) return
      this.$ajax.delete(`/api/ticket/front/people/${item.id}`).then((res) => {
        this.getPeopleInfo()
      })
    },

    addMember() {
      this.showAddMember = true
      this.addType = 'add'
    },

    addPcMember() {
      this.showAddPcMember = true
      this.addType = 'add'
      this.editData = {}
    },

    submitAdd(data) {
      if (this.addType == 'edit') return this.editPersonal(data)
      if (!data.cardNum || !data.personName) {
        return this.$message.warning('请将基础信息填写完整！')
      }
      if (data.phone && !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(data.phone)) return this.$message.warning('请输入正确的手机号') 
      this.postAddPersonal(data)
    },

    postAddPersonal(data) {
      data.museumCode = this.museumCode
      data.cardType = 1
      data.belongId = this.belongId
      data.personType = 1
      this.$ajax.post('/api/ticket/front/people', data).then((res) => {
        this.showAddMember = false
        this.showAddPcMember = false
        this.getPeopleInfo()
      })
    },

    editPersonal(data) {
      this.$ajax.put('/api/ticket/front/people', data).then((res) => {
        this.showAddMember = false
        this.showAddPcMember = false
        this.getPeopleInfo()
      })
    },

    shareAddMember() {
      this.$ajax(`/api/ticket/front/people/invitation-code?id=${this.belongId}`).then((res) => {
        this.codeNumber = res.data
        this.showShareModel = true
      })
    },

    cancelShare() {
      this.showShareModel = false
      this.shareToOthersModel = false
    },

    shareToOthers() {
      this.shareToOthersModel = true
    },

    dissolutionGroup() {
      this.$ajax.delete(`/api/ticket/front/people/disband-team?id=${this.belongId}`).then((res) => {
        //解散团队的同时，删除未提交订单
        this.$ajax.delete(`/api/ticket/front/order/temp-order?id=${this.$route.query.orderId}`).then((res) => {
        })
        this.$message.success('解散成功')
        this.$router.replace(`/ticket/home?museumCode=${this.museumCode}${this.$route.query.id ? `&id=${this.$route.query.id}` : ''}${this.$route.query.code ? `&code=${this.$route.query.code}` : ''}`)
      })
    },

    submitGroupMembers() {
      if (!this.members.length) return this.$message.error('请添加团队成员')
      if (this.$store.state.ticketDetail.orgNumMin && this.members.length < this.$store.state.ticketDetail.orgNumMin - 1) return this.$message.error(`最小团队预约人数为${this.$store.state.ticketDetail.orgNumMin}`)
      if (this.$store.state.ticketDetail.orgNumMax && this.members.length > this.$store.state.ticketDetail.orgNumMax - 1) return this.$message.error(`最大团队预约人数为${this.$store.state.ticketDetail.orgNumMin}`)
      if (!this.hasReadNotice && !this.$store.state.isMobile) return this.$message.error('请阅读并勾选预约须知')
      if (!this.$store.state.isMobile) return this.submit()
      this.showPop = true
      // this.submit()
    },

    submit() {
      if (this.isFid) return this.submitTempOrder()
      let peopleIds = []
      peopleIds.push(this.belongId)
      let data = {
        museumCode: this.museumCode,
        bookingDate: this.jsonData.selectedDate.replace(/\//g, '-'),
        timeSettingId: this.jsonData.timeId,
        orderType: 1,
        peopleIds: peopleIds,
        explainOn: this.jsonData.needExplain == 2 ? true : false,
        belongNum: this.members.length,
        certificate: this.jsonData.imgOrgOn ? (this.$route.params.certificate ? this.$route.params.certificate.join('|') : '') : undefined,
        ticketInfoId: this.$store.state.ticketDetail.id
      }
      if (this.$route.query.flyingCinemaNum || this.$route.query.chairNum) {
        data.flyingCinemaNum = this.$route.query.flyingCinemaNum ? parseInt(this.$route.query.flyingCinemaNum) : 0
        data.chairNum = this.$route.query.chairNum ? parseInt(this.$route.query.chairNum) : 0
      }
      this.$ajax.post('/api/ticket/front/order', data).then((res) => {
        this.$router.push(`/ticket/re_success?museumCode=${this.museumCode}&orderId=${res.data}${this.$store.state.ticketDetail.id ? `&id=${this.$store.state.ticketDetail.id}` : ''}`)
      })
    },

    closePop() {
      this.showPop = false
    },

    getPeopleInfo() {
      this.$ajax(`/api/ticket/front/people/info?museumCode=${this.museumCode}&belongId=${this.belongId}&personType=1`).then((res) => {
        this.members = res.data
        if (this.uploadTime < 3 && !res.data.length) {
          setTimeout(() => {
            this.getPeopleInfo()
            this.uploadTime ++
          }, 2000)
        }
      })
    },

    getGroup() {
      this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.museumCode}&personType=4`).then((res)=> {
        let data = res.data.find((item) => {return item.id == this.belongId})
        if (!data) {
          return this.showPop2 = true
        }
        this.group = data
        var pat =/(\d{3})\d*(\d{4})/;
        let phone = this.group.phone.replace(pat,'$1****$2');
        if ((this.$cookie.get('ticket_phone') != phone)) {
          this.toGroupCode()
        } else if (this.isFid) {
          this.getOrderDetail(this.$route.query.orderId)
        }
      })
    },

    hasRead() {
      if (this.readTime) return
      this.showNotice = false
      this.hasReadNotice = true
      this.hasOpenNotice = true
    },

    // 获取临时订单的信息
    getOrderDetail(id) {
      this.$ajax(`/api/ticket/front/order/temp-order-by-id?id=${id}`).then((res) => {
        this.orderDetail = res.data
        this.detail.time = this.orderDetail.timeRange.replace(':00-', '-').substring(0,11)
        this.detail.bookingDate = this.orderDetail.bookingDate.split(' ')[0]
        // this.group.orgName = this.orderDetail.orgName
        // this.group.personName = this.orderDetail.peopleName
        // this.group.phone = this.orderDetail.phone
      })
    },

    // 提交临时订单
    submitTempOrder() {
      this.$ajax.post(`/api/ticket/front/order/team?tempOrderId=${this.$route.query.orderId}`).then((res)=>{
        if (res.rel) {
          this.$router.push(`/ticket/re_success?museumCode=${this.museumCode}&orderId=${res.data}${this.$store.state.ticketDetail.id ? `&id=${this.$store.state.ticketDetail.id}` : ''}`)
        }
      })
    }
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false
    this.museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
    if (!this.isFid) {
      this.belongId = this.$route.query.belongId
      this.group = this.$store.state.selectGroup || {}
      this.jsonData = this.$route.query
      this.detail.time = this.jsonData.timeLabel
      this.detail.museumName = this.jsonData.museumName
      this.maxExplainNum = this.jsonData.maxExplainNum
    } else{
      this.belongId = this.$route.query.belongId
    }
    if (!this.$cookie.get('token')) {
      return this.showPop2 = true
    }
    this.getPeopleInfo(this.belongId)
    if (this.group.phone) {
      var pat =/(\d{3})\d*(\d{4})/;
      let phone = this.group.phone.replace(pat,'$1****$2');
      if (this.$cookie.get('ticket_phone') != phone) {
        this.toGroupCode()
      }
    }
    // debugger
    if (!this.group.id && this.belongId) {
      this.getGroup()
    }
  },
  watch: {
    showNotice: {
      handler(val, valOld) {
        if (val) {
          if (this.hasOpenNotice) return
          this.readTime = 3
          timeInterval = setInterval(() =>{
            if (!this.readTime) return clearInterval(timeInterval)
            this.readTime --
          }, 1000)
        }
      }
    }
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .groupDetail{
    .shareButton{
      width: unset;
      padding: 0 0.5rem;
      margin-bottom: 0.8rem;
    }
    .shareIcon{
      position: fixed;
      top: 0.5rem;
      right: 0.5rem;
      z-index: 9999;
      color: white;
      img{
        width: 2rem;
        height: 2rem;
      }
      font-size: 0.5rem;
    }
    .itemCard{
      padding: 0.3rem;
      .button{
        font-size: 0.4rem;
        font-weight: 500;
        // width: 2.5rem;
        // height: 1rem;
        border-radius: 0.2rem;
        background-color: #fff;
        line-height: 0.4rem;
        display: inline-block;
        padding: 0.3rem 0.5rem 0.3rem 1.2rem;
      }
      .nameDetail{
        margin-top: 0.3rem;
        .teamOne{
          margin-left: -3px;
          font-size: 12px;
          font-weight: bold;
        }
        .noBorder{
          border-color: rgba(0,0,0,0);
        }
      }
    }
    .explain{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .certificate{
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .hasUpload{
      color: #606266;
    }
    .cancelUpload{
      margin-left: 1rem;
    }
    .members{
      margin: 0.5rem 0.6rem;
      display: flex;
      justify-content: space-between;
      font-size: 0.5rem;
      font-weight: 500;
    }
    .itemTitle{
      display: none;
    }

    .popNotice{
      font-size: 0.5rem;
      margin-bottom: 0.5rem;
    }

    .pcPopContent .pcNotice{
      margin-top: 30%;
      font-size: 40px;
    }
    .group{
      .button{
        margin: 0.1rem 0;
        &:nth-child(1){
          margin-right: 1rem;
          position: relative;
          &::before{
            position: absolute;
            content: '';
            display: inline-block;
            height: 0.5rem;
            width: 0.5rem;
            top: 0.25rem;
            left: 0.42rem;
          }
        }
        &:nth-child(2){
          position: relative;
          &::before{
            position: absolute;
            content: '';
            display: inline-block;
            height: 0.5rem;
            width: 0.5rem;
            top: 0.25rem;
            left: 0.45rem;
          }
        }
      }
    }
    .buttonWarp{
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .pcContent{
      width: unset;
      .contentTitle{
        font-size: 26px;
      }
      .buttonLine{
        width: 7rem;
        margin: auto;
        position: relative;
        div{
          display: inline-block;
        }
        .buttonRed{
          margin-right: 0.5rem;
        }
        .toIndex{
          position: absolute;
          border: 1px solid #333333;
          color: #333333;
          height: 0.2rem;
          width: 0.6rem;
          line-height: 0.2rem;
          border-radius: 0.1rem;
          font-size: 0.03rem;
          top: 0.02rem;
          right: 0.5rem;
          cursor: pointer;
        }
      }
      .line{
        font-size: 0.13rem;
        font-weight: 500;
        text-align: center;
        line-height: 0.23rem;
        margin-left: 0.15rem;
        margin-top: 0.2rem;
        span{
          margin-left: 0.2rem;
          font-size: 0.11rem;
        }
      }
      .itemWarpLine{
        margin-bottom: 0.2rem;
      }

    }
    .pcItemCard{
      margin: 40px auto;
      width: 1020px;
      position: relative;
      .members{
        display: none;
      }
      .itemTitle{
        display: block;
      }
      .group{
        background-color: #fff;
        padding: 0.2rem !important;
      }
      .nameWarp{
        width: 5.5rem;
        .nameDetail{
          margin-left: 0.3rem;
          margin-bottom: 0.15rem;
          margin-top: 0;
          .teamOne{
            margin-left: -2px;
            font-size: 17px;
            font-weight: bold;
          }
        }
      }
      .buttons{
        text-align: left;
        .button{
          text-align: center;
          font-size: 25px;
          line-height: 0.12rem;
          padding: 0.12rem 0.15rem 0.12rem 0.4rem;
          display: inline-block;
          margin: 0 0 0.2rem 0.2rem;
          border: solid 0.01rem #d2d2d2;
          border-radius: 0.1rem;
          color: #000 !important;
          &:before{
            height: 0.16rem;
            width: 0.16rem;
            top: 0.1rem;
            left: 0.15rem;
          }
          &:nth-child(2){
            margin-bottom: 0;
          }
        }
        .buttonText{
          font-size: 0.13rem !important;
          display: inline-block;
          margin-left: 0.2rem;
        }
      }
      .explain{
        justify-content: flex-start;
        position: absolute;
        bottom: -140px;
        left: 0;
        width: 1040px;
        padding: 40px 80px !important;
      }
      .dissolutionGroup{
        position: absolute;
        top: 35px;
        right: 90px;
        font-size: 0.12rem !important;
      }
    }
    .button3{
      margin: auto;
    }
    .popHasRead{
      font-size: 20px;
      width: 160px;
      height: 52px;
      line-height: 52px;
      margin-top: 30px;
    }
    .gayText{
      opacity: 0.9;
      background: #999;
    }
    .popNoticeContent{
      overflow-y: scroll;
      height: 3rem;
    }
    .popContentTitle{
      font-size: 0.3rem;
      text-align: center;
      font-weight: 500;
      margin-bottom: 0.3rem;
    }
    .popNoticeContent .popNotice{
      font-size: 24px;
      line-height: 36px;
      text-align: left;
      // overflow: scroll;
    }
    .popContentTitle{
      font-size: 30px;
      margin-bottom: 40px;
    }
    .popContent{
      .notice{
        font-size: 0.4rem;
      }
    }
    .pcPop{
      .shareButton{
        font-size: 0.3rem;
        height: 0.6rem;
        line-height: 0.6rem;
        margin-bottom: 0.2rem;
      }
    }
  }
</style>
<style type="text/css">
  .groupDetail .upload-demo{
    display: inline-block;
  }
  .groupDetail .popNotice p{
    margin: 0;
  }
  .groupDetail .pcItemCard .title{
    font-size: 25px !important;
  }
</style>


